import styled from 'styled-components'

export default styled.div`
	// display: ${({ show }) => (show ? 'block' : 'hidden')};
	opacity: ${({ show }) => (show ? '1' : '0')};
	transition: height 1s;
	margin: ${({ m }) => m};
`
